import type { SxProps, Theme } from '@mui/material';

export const styles = {
    list: { pt: 0, pr: 2 } as SxProps<Theme>,
    actionItem: {
        backgroundColor: 'white',
        p: 1,
        borderRadius: '8px',
        border: '1px solid #E2E8EE',
        mb: 1,
        maxWidth: 160,
    } as SxProps<Theme>,
    menuItem: { p: 1 } as SxProps<Theme>,
    iconSelected: (theme: Theme) => ({ color: theme.palette.blue[700] }),
    iconDefault: (theme: Theme) => ({ color: theme.palette.grey[700] }),
};
